import React from 'react'

const LauncherIcon3 = () => {
    return (
        <svg
            focusable="false" 
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            viewBox="0 0 16 16"
            strokeLinecap="round" 
            strokeLinejoin="round" 
            height="1.3em"
            width="1.3em"
            style={{ width: '30px', height: '30px' }}
        >
            <path d="M14 0a2 2 0 012 2v12.793a.5.5 0 01-.854.353l-2.853-2.853a1 1 0 00-.707-.293H2a2 2 0 01-2-2V2a2 2 0 012-2h12z"
                strokeWidth="0" fill="currentColor" />
        </svg>
    )
}

export default LauncherIcon3